import styled from 'styled-components'

export const Form = styled.form`
  margin-top: 35px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`

export const FormInputs = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  
  div[data-material-text-field]:first-child {
    margin-top: 0px;
  }
  
  div[data-material-text-field] {
    margin-top: 32px;
  }
`

export default Form
